import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getAccessibleWorkspacesWithCaching, getInvitesWorkspacesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/u")({
    beforeLoad: async ({context}) => {
        const availableWorkspacesResult = await getAccessibleWorkspacesWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
        });
        if (availableWorkspacesResult.success !== true) {
            throw new Error("Failed to get available workspaces", {cause: availableWorkspacesResult.error});
        }

        const availableWorkspaces = availableWorkspacesResult.data;

        const invitedWorkspacesResult = await getInvitesWorkspacesWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
        });
        if (invitedWorkspacesResult.success !== true) {
            throw new Error("Failed to get invited workspaces", {cause: invitedWorkspacesResult.error});
        }

        const invitedWorkspaces = invitedWorkspacesResult.data;

        return {
            availableWorkspaces,
            invitedWorkspaces,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
